import { Routes } from '@angular/router';
import { FapRepository } from '@core/repositories';
import { FapWebRepository } from '@data/repositories';
import { FapsLayoutComponent } from '@app2/core/layout/faps/faps.layout';
import { AsideLayoutComponent } from '@app2/core/layout/aside/aside.layout';
import { authGuardFn } from '@app2/core/guards/auth.guard';
import { SearchLayoutComponent } from '@app2/core/layout/search/search.layout';

export const routes: Routes = [
  {
    path: '',
    component: FapsLayoutComponent,
    pathMatch: 'prefix',
    providers: [
      { provide: FapRepository, useClass: FapWebRepository },
    ],
    loadChildren: () =>
      import('@app2/features/faps/faps.routes').then(c => c.FapsRoutes),
  },
  {
    path: 'search',
    title: 'Sens - Search',
    component: SearchLayoutComponent,
    pathMatch: 'full',
    providers: [],
    loadChildren: () =>
      import('@app2/features/search/search.routes').then(c => c.SearchRoutes),
  },
  {
    path: '',
    component: AsideLayoutComponent,
    children: [
      {
        path: 'profile',
        title: 'Sens - Profile',
        providers: [],
        pathMatch: 'full',
        canActivate: [authGuardFn],
        loadChildren: () =>
          import('@app2/features/profile/profile.routes').then(c => c.ProfileRoutes),
      },
      {
        path: 'payment',
        title: 'Sens - Payment',
        providers: [],
        canActivate: [authGuardFn],
        loadChildren: () =>
          import('@app2/features/payment/payment.routes').then(c => c.PaymentRoutes),
      },
      {
        path: 'documents',
        title: 'Sens - Documents',
        providers: [],
        loadChildren: () =>
          import('@app2/features/documents/documents.routes').then(c => c.DocumentsRoutes),
      },
      {
        path: ':modelId',
        title: 'Sens - Model',
        providers: [],
        loadChildren: () =>
          import('@app2/features/model/model.routes').then(c => c.ModelRoutes),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full',
  },
];
